"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  tabContainer: {
    position: 'relative',
    '&.bottomLine:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      height: 1,
      backgroundColor: theme.tab.borderBottomContainerColor
    }
  },
  tabs: {
    display: 'flex',
    alignItems: 'stretch',
    position: 'relative',
    overflowX: 'auto'
  }
});

exports.default = _default;